import { PrimitiveValueObjectDateTime } from '@/domain/primitiveValueObjectDateTime';

/**
 * 作成日時
 */
export class CreateDatetime extends PrimitiveValueObjectDateTime {
  /**
   * 作成
   * @param value 値
   * @returns 値
   */
  static create(value: Date): CreateDatetime {
    return new CreateDatetime(value);
  }

  /** ラベル */
  static get label(): string {
    return '作成日時';
  }

  /** 文字列にする */
  override toString() {
    const d = this.value;
    return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日 ${d.getHours()}時${d.getMinutes()}分`;
  }
}
